import React from "react";
import { ParamsContext } from "./ParamsContext";

export function withParams(Component) {
  let comp = function ParamsComponent(props) {
    return <ParamsContext.Consumer>{params => <Component {...props} params={params} />}</ParamsContext.Consumer>;
  };
  comp.displayName = `withParams(${getDisplayName(Component)})`;
  return comp;
}
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
